
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12394',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12394",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.469",
  "data-fetching-client": "static-1.9701",
  "foundations-components": "static-1.8001",
  "foundations-components-legacy": "static-1.1026",
  "foundations-theming": "static-1.4454",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8049",
  "hub-http-shared-msw-handlers": "static-1.10053",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11507",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "jasmine-runner": "static-1.6498",
  "marketplace-storefront-base": "static-1.12455",
  "quartz": "static-1.7075",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16709",
  "reactive-variable-buffer-atom": "static-1.2893",
  "reporting-testing-lib": "static-1.9654",
  "settings-ui-lib": "static-1.12554",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7203",
  "ui-addon-i18n": "static-1.11183",
  "ui-addon-react-router-dom": "static-1.9577",
  "unified-auth": "static-1.532",
  "unified-auth-core-lib": "static-1.814",
  "usage-tracker": "static-1.7383",
  "usage-tracker-core": "static-1.7233",
  "customer-data-property-utils": "static-1.8126",
  "hub-http": "static-1.6257",
  "integrations-lib": "static-1.16295",
  "marketplace-ui-common": "static-1.19892",
  "property-management-iframe": "static-1.13287",
  "quartz-config": "static-1.853",
  "quartz-core": "static-1.6294",
  "quartz-routing": "static-1.505",
  "quick-fetch": "static-1.3943",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4687",
  "ts-schema": "static-1.4106",
  "ui-universal-auth": "static-1.9018",
  "UIComponents": "static-3.8453",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3425",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3352",
  "quartz-webpack": "static-1.3299",
  "bend-plugin-quartz-routing": "static-1.153",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4270",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4903",
  "foundations-theming-specialty": "static-1.2170",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9458",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5371",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2041",
  "ui-fonts": "static-1.769",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-theming": "static-1.2937",
  "foundations-theming-base": "static-1.3439",
  "stylex": "static-1.33",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3160",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4361",
  "ai-components-ui-library": "static-1.9066",
  "ai-rendering-library": "static-1.10302",
  "chirp-fetch": "static-1.1922",
  "connections-embed-lib": "static-1.1049",
  "copilot-toolkit": "static-1.11230",
  "feedback-loader": "static-1.29361",
  "laboratory-lib": "static-3.7190",
  "marketplace-embed": "static-1.22203",
  "marketplace-ui-details": "static-1.9787",
  "marketplace-ui-reviews": "static-1.19847",
  "marketplace-ui-tracking": "static-1.14062",
  "sanitize-text": "static-1.8178",
  "ui-addon-video-player": "static-1.8737",
  "usage-tracker-multi": "static-1.5797",
  "usage-tracker-session-replay": "static-1.5069",
  "wootric-nps": "static-1.7007",
  "quartz-head": "static-1.740",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4686",
  "immer": "static-1.33",
  "immerable": "static-1.4188",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2511",
  "reporting-data": "static-1.67721",
  "cssUtils": "static-1.798",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11814",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10242",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10400",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7373",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18424",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4549",
  "foundations-components-test-utils": "static-1.5484",
  "quartz-i18n": "static-1.750",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.354",
  "microsoft-drive-integration-lib": "static-1.481",
  "slack-ui-library": "static-1.10427",
  "fsm": "static-1.3766",
  "customer-data-objects": "static-1.7709",
  "property-translator": "static-1.5433",
  "hs-locale-management": "static-1.108",
  "frontend-preferences-client": "static-1.7962",
  "hs-promise-utils": "static-1.5626",
  "hubspot-apollo-client": "static-1.4913",
  "integrations-error-boundary-lib": "static-1.13710",
  "integrations-tracking-lib": "static-1.5637",
  "native-integrations-shared-strings": "static-1.7816",
  "reselect": "static-2.16",
  "sanitize": "static-1.4510",
  "superstore": "static-1.4795",
  "ui-shepherd-react": "static-3.10216",
  "ai-settings-ui-library": "static-1.7938",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4678",
  "immutable-less": "static-1.4687",
  "marketplace-ui-client-types": "static-1.17299",
  "nav-meta": "static-1.29770",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10282",
  "ui-addon-upgrades": "static-9.18049",
  "inbound-db-properties-service-client": "static-1.3873",
  "property-management-common": "static-1.5575",
  "ui-addon-iframeable": "static-1.9095",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.750",
  "quartz-test": "static-1.750",
  "quartz-tracking": "static-1.454",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.97",
  "bender-build-tools": "static-1.3227",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21452",
  "ContentUtils": "static-1.68480",
  "customer-data-objects-ui-components": "static-1.13065",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.103",
  "avatar-components": "static-1.2533",
  "customer-data-filters-ui": "static-1.39937",
  "customer-data-reference-ui-components": "static-1.13202",
  "embedded-academy-lib": "static-1.14450",
  "ExportDialog": "static-6.10419",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41408",
  "reporting-snowflake": "static-1.56339",
  "reporting-ui-components": "static-2.64992",
  "reporting-visualizations": "static-1.59797",
  "ui-addon-teams": "static-1.21605",
  "magpie-lib": "static-1.5573",
  "navigation-components": "static-1.18133",
  "breeze-engine-lib": "static-1.767",
  "magpie-types": "static-1.5033",
  "simple-logging-lib": "static-1.3085",
  "ai-studio-lib": "static-1.11727",
  "app-governance-lib": "static-1.1663",
  "developer-experience-shared-components": "static-1.10546",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8034",
  "ui-product-approvals": "static-1.28246",
  "ui-tool-access": "static-1.10182",
  "usage-based-billing-components-lib": "static-1.9084",
  "usage-tracker-anonymous": "static-1.5800",
  "usage-tracker-public": "static-1.7194",
  "amplitude-session-replay-browser": "static-1.61",
  "inbound-db-meta-service-client": "static-1.3612",
  "persist-promise": "static-1.3733",
  "reference-resolvers": "static-1.8206",
  "ui-extensibility-client-types": "static-1.3960",
  "hubspot-apollo-cache": "static-1.372",
  "universal-page-editor-lib": "static-1.3049",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2889",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5109",
  "purchase-motions-components": "static-1.5982",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1576",
  "crm-component-utils": "static-1.39185",
  "crm-properties-common-lib": "static-1.5921",
  "customer-data-properties": "static-1.51702",
  "framework-data-schema-resolvers": "static-1.6920",
  "property-value-citations": "static-1.2316",
  "reference-resolvers-lite": "static-1.8130",
  "ui-business-units-lib": "static-1.9092",
  "navigation-messaging": "static-1.7460",
  "hubspotter-http-shared-msw-handlers": "static-1.10051",
  "cms-field-types": "static-1.4847",
  "content-icons-ui": "static-1.2233",
  "customer-data-ui-utilities": "static-1.9860",
  "events-data-lib": "static-1.261",
  "conversations-skeleton-state": "static-1.7283",
  "crm-message-bus": "static-1.43073",
  "customer-data-filters-ui-msw-helpers": "static-1.22372",
  "FormUrlGenerator": "static-2.4753",
  "framework-builder-read-service-client": "static-1.4031",
  "framework-data-schema-quick-fetch": "static-1.6825",
  "multi-account-reference-resolvers": "static-1.1015",
  "onboarding-tours": "static-1.16672",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13791",
  "academy-common-lib": "static-1.13910",
  "content-assistance-lib": "static-1.7804",
  "dashboard-lib": "static-1.81682",
  "file-manager-components": "static-1.23723",
  "getting-started-shared-tasks": "static-1.18552",
  "hubspot-prosemirror": "static-1.18342",
  "hubspot-prosemirror-plugins": "static-1.18334",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19892",
  "share-with-third-party-component-lib": "static-1.8738",
  "ui-addon-draggable": "static-3.4797",
  "ui-asset-management-lib": "static-1.11085",
  "user-context": "static-1.5140",
  "growth-payments-core": "static-1.25492",
  "reporting-plugins": "static-1.10379",
  "reporting-reports": "static-1.67399",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.757",
  "nest": "static-1.264",
  "ably": "static-2.2",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10661",
  "framework-listing-lib": "static-2.28795",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30808",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4287",
  "ui-product-approvals-common": "static-1.141",
  "onboarding-scopes": "static-1.6495",
  "onboarding-tours-client": "static-1.4886",
  "platform-infra-nav-components": "static-1.7698",
  "subscription-experience-data-types": "static-1.14981",
  "crm-record-cards-service-types": "static-1.3615",
  "location-customization-utils-lib": "static-1.9378",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5985",
  "signup-constants": "static-1.18905",
  "signup-ui-url-generator": "static-2.8088",
  "card-properties-lib": "static-1.44312",
  "commerce-subscription-lib": "static-1.37234",
  "crm-actions": "static-1.6368",
  "crm-cards-sdk": "static-1.43705",
  "customer-data-properties-shared-msw-handlers": "static-1.9380",
  "customer-data-tracking": "static-1.6924",
  "hs-resources": "static-1.192",
  "pulse": "static-1.615",
  "calling-global-api": "static-1.64646",
  "calling-internal-common": "static-1.31337",
  "calling-lifecycle-internal": "static-1.66028",
  "calling-lifecycle-messages": "static-1.58322",
  "commerce-products-lib": "static-1.9707",
  "conditional-properties-service-client": "static-1.3824",
  "crm-links": "static-1.6336",
  "external-options-client-types": "static-1.4186",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4249",
  "meetings-icalendar-utils-lib": "static-1.667",
  "multi-currency-client-types": "static-1.3718",
  "object-builder-ui-client": "static-1.48877",
  "pipeline-validation-client-types": "static-1.3991",
  "smart-property-lib": "static-1.7284",
  "tiered-pricing": "static-1.1299",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11025",
  "crm-pipelines-api-client-types": "static-1.4166",
  "fdsr-migration-layer": "static-1.39",
  "react-dnd-compat": "static-1.4649",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1005",
  "growth-data-modal": "static-1.5481",
  "growth-onboarding-confetti": "static-1.3101",
  "growth-onboarding-next-action-utils": "static-1.2034",
  "onboarding-tours-utils": "static-1.738",
  "ui-shepherd-tracker": "static-1.7597",
  "academy-service-client": "static-1.3717",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39222",
  "FileManagerLib": "static-1.39363",
  "video-embed": "static-1.35911",
  "ui-coaching-tips": "static-1.28670",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11419",
  "video-data-lib": "static-1.35077",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8504",
  "payment-link-components": "static-1.23622",
  "ui-addon-emoji-picker": "static-1.9922",
  "EmailSignatureEditor": "static-1.24454",
  "viral-links-lib": "static-1.7102",
  "data-token-picker": "static-1.16466",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.261",
  "timezone-utils": "static-2.5279",
  "seat-types-lib": "static-1.102",
  "getting-started-shared-tasks-store": "static-1.17670",
  "ui-addon-opt": "static-4.8398",
  "campaign-roi-lib": "static-1.9233",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7362",
  "customer-data-views-management": "static-1.25536",
  "framework-data-table": "static-2.12000",
  "marketing-platform-lib": "static-1.6893",
  "nudge-client-utils": "static-1.2659",
  "nudge-custom-ui-functions": "static-1.1094",
  "app-users-service-client": "static-1.5633",
  "app-users-service-types": "static-1.5041",
  "mini-checkout-client": "static-1.26899",
  "onboarding-utils": "static-1.5390",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28655",
  "edison-service-client-types": "static-1.424",
  "crm_data": "static-4.92084",
  "customer-data-sidebar": "static-2.46126",
  "enrichment-properties-lib": "static-1.16402",
  "ui-addon-draggable-compat": "static-2.4292",
  "commerce-billing-lib": "static-1.19195",
  "commerce-shared-components-lib": "static-1.18636",
  "commerce-tools-ui-lib": "static-1.10480",
  "crm-fe-perf": "static-1.22938",
  "bend-plugin-pulse": "static-1.118",
  "event-emitter": "static-1.982",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31344",
  "shared-worker-versioning": "static-1.11071",
  "calling-usage-tracker": "static-1.6576",
  "voice-sms-access-library": "static-1.1156",
  "commerce-permissions": "static-1.808",
  "products-iframe-lib": "static-1.8044",
  "products-ui-components-shared-msw-handlers": "static-1.10435",
  "data-agent-kit": "static-1.248",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10136",
  "policy-lib": "static-1.6811",
  "react-tinymce": "static-1.55354",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10199",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54480",
  "tinymce-plugins": "static-1.57594",
  "tinymce-themes": "static-1.56450",
  "onboarding-data-sync-lib": "static-1.2010",
  "growth-onboarding-next-action-components": "static-1.2062",
  "user-context-client": "static-1.4647",
  "audio-components": "static-1.5966",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36874",
  "urlinator": "static-1.4571",
  "video-components": "static-1.13421",
  "outpost": "static-1.4213",
  "growth-onboarding-feedback-components": "static-1.6614",
  "content-media-composition-data-lib": "static-1.12463",
  "content-media-compositions": "static-2.16470",
  "media-bridge-lib": "static-1.18985",
  "commerce-tours-lib": "static-1.6170",
  "growth-onboarding-reliability": "static-1.5116",
  "sales-checkout-service-client": "static-1.3677",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21735",
  "sales-email-signature-service-client": "static-1.3880",
  "ts-utils-lib": "static-1.207",
  "crm-export-dialog": "static-1.6324",
  "crm-index-associations-lib": "static-1.6475",
  "crm-view-components": "static-1.385",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2416",
  "nudge-renderer-utils": "static-1.2735",
  "whisper-core-api": "static-1.6736",
  "InboxConnectUtils": "static-4.14922",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5639",
  "settings-content-modals": "static-1.46197",
  "crm_universal": "static-1.22066",
  "customer-data-email": "static-1.18093",
  "card-payment-highlight-lib": "static-1.37289",
  "card-subscription-highlight-lib": "static-1.39657",
  "commerce-contract-lib": "static-1.12222",
  "invoices-highlight-card-lib": "static-1.54848",
  "orders-highlight-card-lib": "static-1.21576",
  "products-highlight-card-lib": "static-1.17990",
  "quotes-highlight-card-lib": "static-1.72173",
  "crm-source-interpretation-lib": "static-1.5378",
  "utility-belt": "static-1.2568",
  "payments-enrollment-embed-lib": "static-1.23010",
  "stripe-embedded-components": "static-1.7565",
  "customer-data-rte": "static-1.33101",
  "cv-backend-services": "static-1.1554",
  "growth-onboarding-empty-states": "static-1.5799",
  "payments-post-enroll-local-storage-lib": "static-1.5144",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38263",
  "trials-service-types": "static-1.3939",
  "calling-orchestration-schema": "static-1.35933",
  "sales-views-client-types": "static-1.4294",
  "hub-http-contrib": "static-1.3076",
  "interframe": "static-3.4794",
  "tinymce-data": "static-1.40565",
  "ui-addon-sales-email": "static-1.5245",
  "layout-dnd-components": "static-1.12509",
  "layout-dnd-utils": "static-1.11484",
  "ui-brand-identity-lib": "static-1.15438",
  "NamespacedHubStyle": "static-2.9085",
  "meetings-connect-utils-lib": "static-1.7639",
  "social-insights-client-types": "static-1.22217",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4188",
  "checkout-sdk": "static-3.23742",
  "checkout-service-types": "static-1.3846",
  "company-details-components": "static-1.6230",
  "payment-method-components": "static-1.6933",
  "pricing-pages-ui-components": "static-1.14209",
  "quote-checkout-service-types": "static-1.3503",
  "upgrade-catalog-service-types": "static-1.3555",
  "access-control-lib": "static-1.10470",
  "EmailComponents": "static-1.54864",
  "EmailData": "static-1.53541",
  "redux-less": "static-2.9518",
  "sequences-lib": "static-1.8102",
  "ui-gdpr-components": "static-1.10385",
  "products-ui-components": "static-1.40225",
  "accounting-integrations-ui-components": "static-1.7116",
  "invoices-ui-lib": "static-1.54864",
  "commerce-products-api": "static-1.2353",
  "invoices-iframe-lib": "static-1.56922",
  "quotes-modal-lib": "static-1.102851",
  "quotes-ui-lib": "static-1.80894",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28372",
  "ContentData": "static-1.68555",
  "layout-data-lib": "static-1.9809",
  "hub-http-rxjs": "static-1.804",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3974",
  "billing-payments-client-types": "static-1.4026",
  "react-performance-metrics-lib": "static-1.591",
  "account-and-billing-fintech-outages": "static-3.18635",
  "pricing-pages-api": "static-1.14074",
  "ContentComponents": "static-2.71436",
  "marketing-contacts-lib": "static-1.10174",
  "marketing-email-service-types": "static-1.1930",
  "messaging-editing-lib": "static-1.46387",
  "messaging-usage-based-billing-components-lib": "static-1.1249",
  "automation-ui-source-apps": "static-1.19002",
  "automation-ui-types": "static-1.19920",
  "messaging-types-lib": "static-1.46124",
  "onboarding-settings-client": "static-1.4539",
  "sequences-client-types-lib": "static-1.7959",
  "commerce-tax-lib": "static-1.564",
  "price-books-api": "static-1.937",
  "price-books-components": "static-1.995",
  "property-description-translator": "static-1.3877",
  "ramp-editor": "static-1.233",
  "commerce-analytics-service-client": "static-1.3665",
  "totals-ui-components": "static-1.23715",
  "SalesContentIndexUI": "static-3.9302",
  "advanced-menus-core": "static-1.15181",
  "advanced-menus-lib": "static-1.12119",
  "ui-memberships-settings-lib": "static-1.34155",
  "segments-query-core": "static-1.1453",
  "eligibility-engine-service-types": "static-1.3220",
  "automation-ui-ubb": "static-1.5836",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7374",
  "data-token-views": "static-1.16447",
  "forms-utils-lib": "static-1.12650",
  "payments-embed-points-lib": "static-1.13110",
  "simple-menus-core": "static-1.15180",
  "simple-menus-lib": "static-1.16697",
  "videoconference-integration-components": "static-1.6871",
  "marketing-contacts-client": "static-1.7551",
  "automation-applications-service-types": "static-1.3545",
  "automation-platform-service-types": "static-1.2600",
  "ContentEditorUI": "static-2.77196",
  "short-messages-app-service-client": "static-1.4004",
  "web-interactives-components": "static-1.13818",
  "web-interactives-data": "static-1.13819",
  "messaging-shared-utils-lib": "static-1.698",
  "messaging-user-info-utils-lib": "static-1.868",
  "email-portal-health-service-types": "static-1.1013",
  "line-items-api": "static-1.753",
  "commerce-totals-service-types": "static-1.3845",
  "FireAlarmUi": "static-1.4538",
  "sales-templates-service-types-lib": "static-1.4196",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21856",
  "automation-ui-usage-tracking": "static-1.21319",
  "data-studio-ubb": "static-1.2835",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27120",
  "collaboration-sidebar": "static-1.57921",
  "content-management-data-lib": "static-1.5432",
  "copilot-plugins": "static-1.11203",
  "cta-picker": "static-1.36511",
  "customer-agent-discovery-components-lib": "static-1.3201",
  "editor-components": "static-1.13278",
  "editor-iframe-lib": "static-1.8452",
  "error-messaging-js": "static-1.5228",
  "FormsCommonComponents": "static-1.85961",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10679",
  "SharedLegalStrings": "static-1.1782",
  "smart-content-core": "static-1.42552",
  "smart-content-lib": "static-1.43205",
  "social-composer-lib": "static-1.59316",
  "structured-content-lib": "static-1.25299",
  "theme-previewer-lib": "static-1.53345",
  "tinymce-copilot": "static-1.16548",
  "xray-recommendation-lib": "static-1.7958",
  "automation-ui-routing": "static-1.21277",
  "sql-reporting-client-types": "static-1.5662",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42275",
  "campaigns-utils-lib": "static-1.3217",
  "reporting-enablement": "static-1.23057",
  "chatspot-widget-iframe": "static-1.21443",
  "collaboration-sidebar-common": "static-1.2718",
  "forms-ai-lib": "static-1.4369",
  "codemirror-dlb": "static-1.58755",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6468",
  "report-customization-components": "static-1.13276",
  "data-quality-ui-library": "static-1.13145",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.420",
  "reporting-insights-lib": "static-1.1862"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12394",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.469",
  "data-fetching-client": "/data-fetching-client/static-1.9701",
  "foundations-components": "/foundations-components/static-1.8001",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1026",
  "foundations-theming": "/foundations-theming/static-1.4454",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8049",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10053",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11507",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "jasmine-runner": "/jasmine-runner/static-1.6498",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12455",
  "quartz": "/quartz/static-1.7075",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16709",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2893",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9654",
  "settings-ui-lib": "/settings-ui-lib/static-1.12554",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7203",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11183",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9577",
  "unified-auth": "/unified-auth/static-1.532",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.814",
  "usage-tracker": "/usage-tracker/static-1.7383",
  "usage-tracker-core": "/usage-tracker-core/static-1.7233",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8126",
  "hub-http": "/hub-http/static-1.6257",
  "integrations-lib": "/integrations-lib/static-1.16295",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19892",
  "property-management-iframe": "/property-management-iframe/static-1.13287",
  "quartz-config": "/quartz-config/static-1.853",
  "quartz-core": "/quartz-core/static-1.6294",
  "quartz-routing": "/quartz-routing/static-1.505",
  "quick-fetch": "/quick-fetch/static-1.3943",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4687",
  "ts-schema": "/ts-schema/static-1.4106",
  "ui-universal-auth": "/ui-universal-auth/static-1.9018",
  "UIComponents": "/UIComponents/static-3.8453",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3425",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3352",
  "quartz-webpack": "/quartz-webpack/static-1.3299",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.153",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4270",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4903",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2170",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9458",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5371",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2041",
  "ui-fonts": "/ui-fonts/static-1.769",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2937",
  "foundations-theming-base": "/foundations-theming-base/static-1.3439",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3160",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4361",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9066",
  "ai-rendering-library": "/ai-rendering-library/static-1.10302",
  "chirp-fetch": "/chirp-fetch/static-1.1922",
  "connections-embed-lib": "/connections-embed-lib/static-1.1049",
  "copilot-toolkit": "/copilot-toolkit/static-1.11230",
  "feedback-loader": "/feedback-loader/static-1.29361",
  "laboratory-lib": "/laboratory-lib/static-3.7190",
  "marketplace-embed": "/marketplace-embed/static-1.22203",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9787",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19847",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14062",
  "sanitize-text": "/sanitize-text/static-1.8178",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8737",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5797",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5069",
  "wootric-nps": "/wootric-nps/static-1.7007",
  "quartz-head": "/quartz-head/static-1.740",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4686",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4188",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2511",
  "reporting-data": "/reporting-data/static-1.67721",
  "cssUtils": "/cssUtils/static-1.798",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11814",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10242",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10400",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7373",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18424",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4549",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5484",
  "quartz-i18n": "/quartz-i18n/static-1.750",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.354",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.481",
  "slack-ui-library": "/slack-ui-library/static-1.10427",
  "fsm": "/fsm/static-1.3766",
  "customer-data-objects": "/customer-data-objects/static-1.7709",
  "property-translator": "/property-translator/static-1.5433",
  "hs-locale-management": "/hs-locale-management/static-1.108",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7962",
  "hs-promise-utils": "/hs-promise-utils/static-1.5626",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4913",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13710",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5637",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7816",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4510",
  "superstore": "/superstore/static-1.4795",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10216",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7938",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4678",
  "immutable-less": "/immutable-less/static-1.4687",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17299",
  "nav-meta": "/nav-meta/static-1.29770",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10282",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18049",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3873",
  "property-management-common": "/property-management-common/static-1.5575",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9095",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.750",
  "quartz-test": "/quartz-test/static-1.750",
  "quartz-tracking": "/quartz-tracking/static-1.454",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.97",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21452",
  "ContentUtils": "/ContentUtils/static-1.68480",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13065",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.103",
  "avatar-components": "/avatar-components/static-1.2533",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39937",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13202",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14450",
  "ExportDialog": "/ExportDialog/static-6.10419",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41408",
  "reporting-snowflake": "/reporting-snowflake/static-1.56339",
  "reporting-ui-components": "/reporting-ui-components/static-2.64992",
  "reporting-visualizations": "/reporting-visualizations/static-1.59797",
  "ui-addon-teams": "/ui-addon-teams/static-1.21605",
  "magpie-lib": "/magpie-lib/static-1.5573",
  "navigation-components": "/navigation-components/static-1.18133",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.767",
  "magpie-types": "/magpie-types/static-1.5033",
  "simple-logging-lib": "/simple-logging-lib/static-1.3085",
  "ai-studio-lib": "/ai-studio-lib/static-1.11727",
  "app-governance-lib": "/app-governance-lib/static-1.1663",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10546",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8034",
  "ui-product-approvals": "/ui-product-approvals/static-1.28246",
  "ui-tool-access": "/ui-tool-access/static-1.10182",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9084",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5800",
  "usage-tracker-public": "/usage-tracker-public/static-1.7194",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.61",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3612",
  "persist-promise": "/persist-promise/static-1.3733",
  "reference-resolvers": "/reference-resolvers/static-1.8206",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3960",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.372",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3049",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2889",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5109",
  "purchase-motions-components": "/purchase-motions-components/static-1.5982",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1576",
  "crm-component-utils": "/crm-component-utils/static-1.39185",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5921",
  "customer-data-properties": "/customer-data-properties/static-1.51702",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6920",
  "property-value-citations": "/property-value-citations/static-1.2316",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8130",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9092",
  "navigation-messaging": "/navigation-messaging/static-1.7460",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10051",
  "cms-field-types": "/cms-field-types/static-1.4847",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9860",
  "events-data-lib": "/events-data-lib/static-1.261",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7283",
  "crm-message-bus": "/crm-message-bus/static-1.43073",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22372",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4753",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4031",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6825",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1015",
  "onboarding-tours": "/onboarding-tours/static-1.16672",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13791",
  "academy-common-lib": "/academy-common-lib/static-1.13910",
  "content-assistance-lib": "/content-assistance-lib/static-1.7804",
  "dashboard-lib": "/dashboard-lib/static-1.81682",
  "file-manager-components": "/file-manager-components/static-1.23723",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18552",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18342",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18334",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19892",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8738",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4797",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11085",
  "user-context": "/user-context/static-1.5140",
  "growth-payments-core": "/growth-payments-core/static-1.25492",
  "reporting-plugins": "/reporting-plugins/static-1.10379",
  "reporting-reports": "/reporting-reports/static-1.67399",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.757",
  "nest": "/nest/static-1.264",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10661",
  "framework-listing-lib": "/framework-listing-lib/static-2.28795",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30808",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4287",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.141",
  "onboarding-scopes": "/onboarding-scopes/static-1.6495",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4886",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7698",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14981",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9378",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5985",
  "signup-constants": "/signup-constants/static-1.18905",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8088",
  "card-properties-lib": "/card-properties-lib/static-1.44312",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37234",
  "crm-actions": "/crm-actions/static-1.6368",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43705",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9380",
  "customer-data-tracking": "/customer-data-tracking/static-1.6924",
  "hs-resources": "/hs-resources/static-1.192",
  "pulse": "/pulse/static-1.615",
  "calling-global-api": "/calling-global-api/static-1.64646",
  "calling-internal-common": "/calling-internal-common/static-1.31337",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66028",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58322",
  "commerce-products-lib": "/commerce-products-lib/static-1.9707",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3824",
  "crm-links": "/crm-links/static-1.6336",
  "external-options-client-types": "/external-options-client-types/static-1.4186",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4249",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.667",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3718",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48877",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3991",
  "smart-property-lib": "/smart-property-lib/static-1.7284",
  "tiered-pricing": "/tiered-pricing/static-1.1299",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11025",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4166",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.39",
  "react-dnd-compat": "/react-dnd-compat/static-1.4649",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1005",
  "growth-data-modal": "/growth-data-modal/static-1.5481",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3101",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2034",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.738",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7597",
  "academy-service-client": "/academy-service-client/static-1.3717",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39222",
  "FileManagerLib": "/FileManagerLib/static-1.39363",
  "video-embed": "/video-embed/static-1.35911",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28670",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11419",
  "video-data-lib": "/video-data-lib/static-1.35077",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8504",
  "payment-link-components": "/payment-link-components/static-1.23622",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9922",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24454",
  "viral-links-lib": "/viral-links-lib/static-1.7102",
  "data-token-picker": "/data-token-picker/static-1.16466",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.261",
  "timezone-utils": "/timezone-utils/static-2.5279",
  "seat-types-lib": "/seat-types-lib/static-1.102",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17670",
  "ui-addon-opt": "/ui-addon-opt/static-4.8398",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9233",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7362",
  "customer-data-views-management": "/customer-data-views-management/static-1.25536",
  "framework-data-table": "/framework-data-table/static-2.12000",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6893",
  "nudge-client-utils": "/nudge-client-utils/static-1.2659",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1094",
  "app-users-service-client": "/app-users-service-client/static-1.5633",
  "app-users-service-types": "/app-users-service-types/static-1.5041",
  "mini-checkout-client": "/mini-checkout-client/static-1.26899",
  "onboarding-utils": "/onboarding-utils/static-1.5390",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28655",
  "edison-service-client-types": "/edison-service-client-types/static-1.424",
  "crm_data": "/crm_data/static-4.92084",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46126",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16402",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4292",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19195",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18636",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10480",
  "crm-fe-perf": "/crm-fe-perf/static-1.22938",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.118",
  "event-emitter": "/event-emitter/static-1.982",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31344",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11071",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6576",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1156",
  "commerce-permissions": "/commerce-permissions/static-1.808",
  "products-iframe-lib": "/products-iframe-lib/static-1.8044",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10435",
  "data-agent-kit": "/data-agent-kit/static-1.248",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10136",
  "policy-lib": "/policy-lib/static-1.6811",
  "react-tinymce": "/react-tinymce/static-1.55354",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10199",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54480",
  "tinymce-plugins": "/tinymce-plugins/static-1.57594",
  "tinymce-themes": "/tinymce-themes/static-1.56450",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2010",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2062",
  "user-context-client": "/user-context-client/static-1.4647",
  "audio-components": "/audio-components/static-1.5966",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36874",
  "urlinator": "/urlinator/static-1.4571",
  "video-components": "/video-components/static-1.13421",
  "outpost": "/outpost/static-1.4213",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6614",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12463",
  "content-media-compositions": "/content-media-compositions/static-2.16470",
  "media-bridge-lib": "/media-bridge-lib/static-1.18985",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6170",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5116",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3677",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21735",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3880",
  "ts-utils-lib": "/ts-utils-lib/static-1.207",
  "crm-export-dialog": "/crm-export-dialog/static-1.6324",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6475",
  "crm-view-components": "/crm-view-components/static-1.385",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2416",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2735",
  "whisper-core-api": "/whisper-core-api/static-1.6736",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14922",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5639",
  "settings-content-modals": "/settings-content-modals/static-1.46197",
  "crm_universal": "/crm_universal/static-1.22066",
  "customer-data-email": "/customer-data-email/static-1.18093",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37289",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39657",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12222",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54848",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21576",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17990",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72173",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5378",
  "utility-belt": "/utility-belt/static-1.2568",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23010",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7565",
  "customer-data-rte": "/customer-data-rte/static-1.33101",
  "cv-backend-services": "/cv-backend-services/static-1.1554",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5799",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5144",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38263",
  "trials-service-types": "/trials-service-types/static-1.3939",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35933",
  "sales-views-client-types": "/sales-views-client-types/static-1.4294",
  "hub-http-contrib": "/hub-http-contrib/static-1.3076",
  "interframe": "/interframe/static-3.4794",
  "tinymce-data": "/tinymce-data/static-1.40565",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5245",
  "layout-dnd-components": "/layout-dnd-components/static-1.12509",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11484",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15438",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9085",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7639",
  "social-insights-client-types": "/social-insights-client-types/static-1.22217",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4188",
  "checkout-sdk": "/checkout-sdk/static-3.23742",
  "checkout-service-types": "/checkout-service-types/static-1.3846",
  "company-details-components": "/company-details-components/static-1.6230",
  "payment-method-components": "/payment-method-components/static-1.6933",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14209",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3503",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3555",
  "access-control-lib": "/access-control-lib/static-1.10470",
  "EmailComponents": "/EmailComponents/static-1.54864",
  "EmailData": "/EmailData/static-1.53541",
  "redux-less": "/redux-less/static-2.9518",
  "sequences-lib": "/sequences-lib/static-1.8102",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10385",
  "products-ui-components": "/products-ui-components/static-1.40225",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7116",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54864",
  "commerce-products-api": "/commerce-products-api/static-1.2353",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56922",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102851",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80894",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28372",
  "ContentData": "/ContentData/static-1.68555",
  "layout-data-lib": "/layout-data-lib/static-1.9809",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.804",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3974",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4026",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.591",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18635",
  "pricing-pages-api": "/pricing-pages-api/static-1.14074",
  "ContentComponents": "/ContentComponents/static-2.71436",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10174",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1930",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46387",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1249",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19002",
  "automation-ui-types": "/automation-ui-types/static-1.19920",
  "messaging-types-lib": "/messaging-types-lib/static-1.46124",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4539",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7959",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.564",
  "price-books-api": "/price-books-api/static-1.937",
  "price-books-components": "/price-books-components/static-1.995",
  "property-description-translator": "/property-description-translator/static-1.3877",
  "ramp-editor": "/ramp-editor/static-1.233",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3665",
  "totals-ui-components": "/totals-ui-components/static-1.23715",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9302",
  "advanced-menus-core": "/advanced-menus-core/static-1.15181",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12119",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34155",
  "segments-query-core": "/segments-query-core/static-1.1453",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3220",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5836",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7374",
  "data-token-views": "/data-token-views/static-1.16447",
  "forms-utils-lib": "/forms-utils-lib/static-1.12650",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13110",
  "simple-menus-core": "/simple-menus-core/static-1.15180",
  "simple-menus-lib": "/simple-menus-lib/static-1.16697",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6871",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7551",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3545",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2600",
  "ContentEditorUI": "/ContentEditorUI/static-2.77196",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4004",
  "web-interactives-components": "/web-interactives-components/static-1.13818",
  "web-interactives-data": "/web-interactives-data/static-1.13819",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.698",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.868",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1013",
  "line-items-api": "/line-items-api/static-1.753",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3845",
  "FireAlarmUi": "/FireAlarmUi/static-1.4538",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4196",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21856",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21319",
  "data-studio-ubb": "/data-studio-ubb/static-1.2835",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27120",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57921",
  "content-management-data-lib": "/content-management-data-lib/static-1.5432",
  "copilot-plugins": "/copilot-plugins/static-1.11203",
  "cta-picker": "/cta-picker/static-1.36511",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3201",
  "editor-components": "/editor-components/static-1.13278",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8452",
  "error-messaging-js": "/error-messaging-js/static-1.5228",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85961",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10679",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1782",
  "smart-content-core": "/smart-content-core/static-1.42552",
  "smart-content-lib": "/smart-content-lib/static-1.43205",
  "social-composer-lib": "/social-composer-lib/static-1.59316",
  "structured-content-lib": "/structured-content-lib/static-1.25299",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53345",
  "tinymce-copilot": "/tinymce-copilot/static-1.16548",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7958",
  "automation-ui-routing": "/automation-ui-routing/static-1.21277",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5662",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42275",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3217",
  "reporting-enablement": "/reporting-enablement/static-1.23057",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21443",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2718",
  "forms-ai-lib": "/forms-ai-lib/static-1.4369",
  "codemirror-dlb": "/codemirror-dlb/static-1.58755",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6468",
  "report-customization-components": "/report-customization-components/static-1.13276",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13145",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.420",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1862"
}
};
